import { inject } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../services/auth.service';

/** Lezen mag altijd. */
const LEZEN = ['GET', 'HEAD', 'OPTIONS'];

/**
 * Wat de app zelf op de achtergrond schrijft (gebruik bijhouden, het
 * welkomstvenster). Dat is van de gebruiker, niet van wie meekijkt: zonder
 * melding laten vallen, anders verscheen "View only" bij elke klik.
 */
const STIL = ['/Monitoring/Activity', '/Onboarding/'];

/** Hooguit één melding per zoveel tijd, ook als een pagina drie dingen tegelijk wil opslaan. */
const RUST_MS = 4000;
let laatsteMelding = 0;

/**
 * Meekijken als een gebruiker ("Open as user" in de beheerconsole, eigenaar
 * 25-10-2026: "Alleen meekijken"). De server weigert dan alles behalve lezen
 * (siq_auth MeekijkenAlleenLezenFilter, Arch MeekijkRegel). Hier gaat zo'n
 * verzoek niet eens de deur uit, en zegt de app één keer waarom, in plaats van
 * een kale foutmelding. Verversen van het token mag wel: dat houdt het
 * meekijken na een herlaadbeurt in stand (de eindtijd schuift niet op).
 */
export const meekijkenInterceptorProvider = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const auth = inject(AuthService);
  if (!auth.meekijken || LEZEN.includes(request.method.toUpperCase()) || request.url.endsWith('/Account/Refresh')) {
    return next(request);
  }
  if (STIL.some(pad => request.url.includes(pad))) {
    return EMPTY;
  }
  const nu = Date.now();
  if (nu - laatsteMelding > RUST_MS) {
    laatsteMelding = nu;
    const naam = [auth.user?.firstName, auth.user?.lastName].filter(Boolean).join(' ');
    inject(ToastrService).info(inject(TranslateService).instant('MEEKIJKEN.niet_opgeslagen', { naam }));
  }
  return throwError(() => new HttpErrorResponse({
    status: 403,
    statusText: 'View only',
    url: request.url,
    error: { key: 'view_only', Key: 'view_only' },
  }));
};

/** Alleen voor de specs: de rust tussen meldingen terugzetten. */
export function resetMeekijkMelding(): void {
  laatsteMelding = 0;
}
